import type { QueryKey } from '$lib/api/tanstack-query';

const base = ['location'] as const;
const listBase = [...base, 'list'] as const;
const metadataBase = [...base, 'metadata'] as const;

export const locationKeys = {
  get: (locationID: string | undefined) => [...base, { locationID }],
  list: (organizationID: string | undefined) => [
    ...listBase,
    { organizationID },
  ],
  listLocKeys: (locationID: string | undefined) =>
    [...locationKeys.get(locationID), 'listLocKeys'] as const,
  membersAndInvites: (locationID: string | undefined) =>
    [...locationKeys.get(locationID), 'membersAndInvites'] as const,
  locationMetadata: (locationID: string | undefined) => [
    ...metadataBase,
    { locationID },
  ],
};

export interface KeyFilters {
  locationID?: string;
  organizationID?: string;
  locationMetadata?: boolean;
  allLists?: boolean;
  all?: boolean;
}

/** Returns a list of relevant location query keys. Useful for invalidation. */
export const getLocationQueryKeys = ({
  locationID,
  organizationID,
  locationMetadata,
  allLists,
  all,
}: KeyFilters): readonly QueryKey[] => {
  const queryKeys = [];

  if (all) {
    return [base];
  }

  if (locationID !== undefined) {
    queryKeys.push(locationKeys.get(locationID));
  }

  if (locationMetadata) {
    queryKeys.push(locationKeys.locationMetadata(locationID));
  }

  if (allLists) {
    queryKeys.push(listBase);
  } else if (organizationID !== undefined) {
    queryKeys.push(locationKeys.list(organizationID));
  }

  return queryKeys;
};
